var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCompete16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2V1H4V2H0V5C0 7.20914 1.79086 9 4 9H4.53513C5.06545 9.91676 5.94916 10.6035 7 10.874V13H6C4.89543 13 4 13.8954 4 15H12C12 13.8954 11.1046 13 10 13H9V10.874C10.0508 10.6035 10.9346 9.91676 11.4649 9H12C14.2091 9 16 7.20914 16 5V2H12ZM10 3H6V7C6 8.10457 6.89543 9 8 9C9.10457 9 10 8.10457 10 7V3ZM12 4V7C13.1046 7 14 6.10457 14 5V4H12ZM2 4H4V7C2.89543 7 2 6.10457 2 5V4Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompete16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;